import styled from 'styled-components/native';

export default styled.View<{ status: any }>`
  flex: 1;
  justify-content: ${({ status }) => (status ? 'space-between' : 'flex-start')};
  padding: ${({ theme }) => (theme.media.tabletLandscape ? '10px' : '0 0 0 10px')};
`;
